import { App } from 'vue';

import ThresholdVisualizer from '@/components/Cart/ThresholdsBar/ThresholdVisualizer.vue';
import { initHobbiiStarter } from '@/shared/instances/hobbii-starter';
import { useCartStore } from '@/shared/pinia/modules/cart';

import type { InitializationState } from './index';
import { thresholdVisualizerMountSelector } from './index';
import { initializeComponent } from './shared';

export const initThresholdVisualizer = async (
  waitForCartUpdate = false,
  mountedApps: Map<string, App>,
  initializationState: InitializationState
): Promise<void> => {
  const containerId = 'threshold-visualizer';

  await initHobbiiStarter();

  await initializeComponent({
    containerId,
    mountSelector: thresholdVisualizerMountSelector,
    component: ThresholdVisualizer,
    state: initializationState.thresholdVisualizer,
    mountedApps,
    waitForCartUpdate,
    extractProps: (container) => {
      const dataset = container.dataset;
      const shippingThreshold = Number(dataset.shippingThreshold || 0);
      const giftThreshold = Number(dataset.giftThreshold || 0);
      const scenario = dataset.scenario || 'none';
      const initialShowThreshold = Number(dataset.initialShowThreshold || 0);
      const giftCollectionHandle = dataset.giftCollectionHandle || '';

      return {
        shippingThreshold,
        giftThreshold,
        scenario,
        initialShowThreshold,
        giftCollectionHandle,
        design: 'rounded' as const
      };
    },
    onBeforeMount: (props) => {
      if (props.giftThreshold > 0) {
        useCartStore().setGiftThreshold(props.giftThreshold);
      }
    },
    shouldProcessPendingRequest: (id, apps) => {
      return !apps.has(id);
    }
  });
};
